module.exports = __webpack_public_path__ + "img/picto-dossier.29a149e5.svg";